module.exports = __webpack_public_path__ + "static/Helvetica-2ce7bccbe71ea34eeb77b96f72ac56a9.ttf";